/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useEffect, useMemo, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { Carousel, Container, Image, CustomImageDot } from 'app/components';
import { Title, PortraitWrapper } from './styles';

const propTypes = {
  portraitDetails: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
  getPortrait: PropTypes.func.isRequired
};

const defaultProps = {
  portraitDetails: []
};

const sliderPropsConfig = () => ({
  slidesToSlide: 1,
  showDots: true,
  ssr: true,
  partialVisible: true,
  autoPlay: true,
  autoPlaySpeed: 4000,
  infinite: true,
  responsive: {
    desktop: {
      breakpoint: {
        max: 30000,
        min: 0
      },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  }
});

const Portrait = ({ portraitDetails, getPortrait }) => {
  const [t, i18n] = useTranslation();
  const { language } = i18n;
  const sliderRef = useRef(null);

  const [portraitData, setPortraitData] = useState({
    headline: '',
    gallery: [
      'https://media.istockphoto.com/photos/office-skysraper-in-the-sun-picture-id523875332?b=1&k=20&m=523875332&s=612x612&w=0&h=hQrhhA0zbzz1l3ZVUXfwz7ou5Xig3kEw0rtGtj3ADO0=',
      'https://media.istockphoto.com/photos/office-skysraper-in-the-sun-picture-id523875332?b=1&k=20&m=523875332&s=612x612&w=0&h=hQrhhA0zbzz1l3ZVUXfwz7ou5Xig3kEw0rtGtj3ADO0=',
      'https://media.istockphoto.com/photos/office-skysraper-in-the-sun-picture-id523875332?b=1&k=20&m=523875332&s=612x612&w=0&h=hQrhhA0zbzz1l3ZVUXfwz7ou5Xig3kEw0rtGtj3ADO0=',
      'https://media.istockphoto.com/photos/office-skysraper-in-the-sun-picture-id523875332?b=1&k=20&m=523875332&s=612x612&w=0&h=hQrhhA0zbzz1l3ZVUXfwz7ou5Xig3kEw0rtGtj3ADO0='
    ],
    description: '',
    subpoints: []
  });

  useEffect(() => {
    getPortrait();
  }, []);

  useEffect(() => {
    if (portraitDetails?.length) {
      setPortraitData(portraitDetails[0]);
    }
  }, [portraitDetails]);

  const languageContents = useMemo(
    () => ({
      headline: language === 'en' ? 'headlineEN' : 'headline',
      description: language === 'en' ? 'descriptionEN' : 'description'
    }),
    [language]
  );

  const sliderProps = useMemo(() => sliderPropsConfig(), []);

  return (
    <Container>
      {portraitData?.headline && (
        <>
          <Title>{t('common.portrait')}</Title>
          <PortraitWrapper>
            <h2>{portraitData?.[languageContents.headline]}</h2>
            <div className="portrait__carousel-wrapper">
              <Carousel
                {...sliderProps}
                refEl={sliderRef}
                className="portrait__carousel"
                customDot={<CustomImageDot images={portraitData?.gallery} />}
              >
                {portraitData?.gallery?.map((item, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Image key={index} src={item} className="portrait__carousel-image" />
                ))}
              </Carousel>
            </div>
            <div className="portrait__description">
              {parse(portraitData?.[languageContents.description])}
            </div>
            <div>
              {portraitData?.subpoints.map(item => (
                <div key={item} className="portrait__item">
                  <h3>{item?.[languageContents.headline]}</h3>
                  {item?.picture?.length > 1 && <Image src={item?.picture} className="portrait__item-image" />}
                  <div className="portrait__description">
                    {parse(item?.[languageContents.description])}
                  </div>
                </div>
              ))}
            </div>
          </PortraitWrapper>
        </>
      )}
    </Container>
  );
};

Portrait.propTypes = propTypes;
Portrait.defaultProps = defaultProps;

export default Portrait;
